import { createEvent, createStore, restore, sample } from 'effector'
import {
  TCreateBalanceOperation,
  TCreateBalanceOperationRequest,
  TCreatePartnerBalanceOperationRequest,
} from './types'
import { fx } from '../../../../libs'
import { getAccounts } from '../../../clients/widgets/account/model'
import { getWallets } from '../../../clients/widgets/wallet/model'
import { Account } from '../../../clients/widgets/account/types'
import { Wallet } from '../../../clients/widgets/wallet/types'

export const setBalanceOperation = createEvent<TCreateBalanceOperation>()

export const submitCreateBalanceOperation =
  createEvent<TCreateBalanceOperationRequest>()

export const submitCreatePartnerBalanceOperation =
  createEvent<TCreatePartnerBalanceOperationRequest>()

export const $balanceOperation = restore(setBalanceOperation, {
  clientId: '',
  sourceId: '',
  sourceType: '',
  comment: '',
  internalComment: '',
  amount: '',
})

export const accountsMounted = createEvent<{ id: string }>()

export const walletsMounted = createEvent<{ id: string }>()

export const resetAccountsError = createEvent()

export const resetWalletsError = createEvent()

export const $accounts = restore<Account[]>(
  getAccounts.doneData.map((doneData) => doneData.body),
  [],
).reset(getAccounts.failData)

export const $wallets = restore<Wallet[]>(
  getWallets.doneData.map((doneData) => doneData.body),
  [],
).reset(getWallets.failData)

export const $accountsError = createStore<string | null>(null)
  .on(getAccounts.failData, (_, error) => {
    return error.body.message || 'Произошла ошибка при загрузке accounts'
  })
  .reset([getAccounts.done, resetAccountsError])

export const $walletsError = createStore<string | null>(null)
  .on(getWallets.failData, (_, error) => {
    return error.body.message || 'Произошла ошибка при загрузке wallets'
  })
  .reset([getWallets.done, resetWalletsError])

export const createBalanceOperation = fx<TCreateBalanceOperationRequest, void>({
  method: 'POST',
  url: '/balance_operation',
})
export const createPartnerBalanceOperation = fx<
  { withdrawalAmountDiff: number; comment: string },
  void
>({
  method: 'PUT',
  url: '/partner/withdrawal_amount/{id}',
})

sample({
  //@ts-ignore
  clock: submitCreateBalanceOperation,
  fn: (balanceOperation) => {
    if (balanceOperation.sourceType == 'partner_wallet') {
      return {
        method: 'PUT',
        url: `/partner/withdrawal_amount/${balanceOperation.clientId}`,
        body: {
          withdrawalAmountDiff: Number(balanceOperation.amount),
          comment: balanceOperation.comment,
        },
        target: createPartnerBalanceOperation,
      }
    } else {
      return {
        method: 'POST',
        url: `/balance_operation`,
        body: { ...balanceOperation },
      }
    }
  },
  target: createBalanceOperation,
})

sample({
  clock: [accountsMounted],
  fn: (account) => {
    return {
      query: {
        populate: JSON.stringify(['Account']),
      },
      url: `/client/${account.id}/accounts`,
    }
  },
  target: [getAccounts],
})

sample({
  clock: [walletsMounted],
  fn: (wallet) => {
    return {
      url: `/client/${wallet.id}/wallets`,
    }
  },
  target: [getWallets],
})
